export default "assets/ef0d402db0543549be5ddb3eda1158b8.jpg";